export default __webpack_public_path__ + "static/media/prokraya-logo-new1.371be322.png";